import {useTheme} from "@mui/material/styles";

import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const Breadcrumb = ({breadcrumbs, welcome_msg}) => {
    const theme = useTheme();

    return (
        <Paper style={{display: 'flex'}} sx={{
            px: 2,
            pb: 2,
            background: theme.palette.background_breadcrumb.default,
            position: 'sticky'
        }}>
            <Stack spacing={2}>
                <Container maxWidth={'xl'} sx={{paddingTop: '15px'}}>
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        aria-label="breadcrumb"
                    >
                        {breadcrumbs}
                    </Breadcrumbs>
                    <Box color={'text.secondary'}>
                        <h2 style={{color: 'text.primary', marginTop: 0, marginBottom: 0}}>{welcome_msg}</h2>
                    </Box>
                </Container>
            </Stack>
        </Paper>
    );
}

export default Breadcrumb;